export default __webpack_public_path__ + "static/media/icon_big_match_profile.90d20024.svg";